import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

export default function Badge({ children, className }) {
  return (
    <span
      className={classnames('br-pill nowrap ml2 pv1 ph4 f1 f2-md', className)}
    >
      {children}
    </span>
  );
}

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

Badge.defaultProps = {
  className: null
};
